// AccordionItem.jsx
import { useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import "./AccordionItem.css";

export default function AccordionItem({ title, children }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="accordion-item">
      <div
        className={`accordion-header ${open ? "active" : ""}`}
        onClick={() => setOpen(!open)}
      >
        <span>{title}</span>
        <FiChevronDown className={`arrow ${open ? "open" : ""}`} />
      </div>

      {open && <div className="accordion-content">{children}</div>}
    </div>
  );
}
